import { useState, forwardRef, useImperativeHandle } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { useAuth } from '../auth/AuthProvider';
import { Button } from 'react-bootstrap';
import Loading from '../loading/Loading';
import { updateConsents } from '../../controllers/user';
import { useToast } from '../toast/ToastContext';

const PerfilPermisosForm = forwardRef((props, ref) => {
  const [photoConsentTime, setPhotoConsentTime] = useState(new Date(props.consents[0]?.createdAt).getTime() || 0);
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();
  const showToast = useToast();

  useImperativeHandle(ref, () => ({
    getPermisos() {
      return generatePermisos();
    }
  }));

  function generatePermisos() {
    return [
      { createdAt: photoConsentTime }
    ]
  }

  async function submitUpdate() {
    setLoading(true);
    try {
      await updateConsents(token, props.userId);
      showToast({
        message: 'La información se actualizó con éxito.',
        bg: 'success',
        autohide: true,
        delay: 7000,
        title: 'Permisos actualizados'
      });
    }
    catch (e) {
      showToast({
        message: 'Ocurrió un error. Por favor intenta de nuevo más tarde.',
        bg: 'danger',
        autohide: true,
        delay: 7000,
        title: 'Error al actualizar permisos'
      });
    }
    setLoading(false);
  }

  function renderSaveButton() {
    if (props.updateProfile && !(props.consents && props.consents[0]?.createdAt)) {
      return <Form.Group className="mb-3 submit-buttons-wrapper">
        <Button key='submit-btn-permisos' type='submit' variant='primary' onClick={submitUpdate} disabled={!photoConsentTime}>Guardar</Button>
      </Form.Group>;
    }
  }

  if (loading) {
    return <Row>
      <Loading text="Actualizando cuenta..." />
    </Row>
  }

  return <Row>
    <Col>
      <p>Grabación audiovisual y fotografía</p>
      <ul>
        <li>Doy mi consentimiento para cualquier grabación de video, grabación de audio, y fotografías tomadas, a mi, mi cónyuge y/o a mi familia durante las actividades de FAMA.</li>
        <li>Este permiso es gratuito y sin regalías, para cualquier uso, reproducción, publicación o difusión, en cualquier formato.</li>
      </ul>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Check
            type="checkbox"
            id="photoConsentCheckbox"
            label="Reconozco y estoy de acuerdo con las declaraciones anteriores."
            required
            checked={photoConsentTime}
            onChange={(e) => setPhotoConsentTime(e.target.checked ? Date.now() : 0)}
            disabled={!!(props.consents && props.consents[0]?.createdAt)}
          />
      </Form.Group>

      {renderSaveButton()}

    </Col>
  </Row>;
});

export default PerfilPermisosForm;